
angular.module('tf.directives')

    .directive('colorpicker', function() {


    return {
        restrict: 'E',
        template: '<input class="colorpicker"/>',
        replace: true,
        scope:{
            color : "="
        },
        link : function(scope,element,attr){
            $(element).spectrum({
                color: scope.color,
                //allowEmpty: true,
                showAlpha: true,
                showInput: true,
                preferredFormat: 'hex3',
                //containerClassName: 'colorpicker-container',
                replacerClassName: 'colorpicker-replacer',
                move : function(color) {
                    scope.color = color.toHexString();
                    scope.$apply();
                },
                hide : function(color) {
                    scope.color = color.toHexString();
                    scope.$apply();
                }
            });
            scope.$on('$destroy', function() {
                $(element).spectrum('destroy');
            });
        }
    };

});